import { Link, useLocation } from 'react-router-dom'
import type { BreadcrumbItem } from '@/api/endpoints'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'

type BreadcrumbProps = {
  items: BreadcrumbItem[]
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const location = useLocation()

  if (!items?.length) return null

  return (
    <nav aria-label="Хлебные крошки" className="text-[13px] text-breadcrumb-primary overflow-hidden">
      <Swiper
        modules={[FreeMode]}
        slidesPerView="auto"
        spaceBetween={6}
        freeMode={{
          enabled: true,
          sticky: false,
        }}
        preventClicks={true}
        preventClicksPropagation={true}
        className="w-full"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          const href = item.path.startsWith('http') ? item.path : `${item.path}`

          return (
            <SwiperSlide key={index} className="w-auto!">
              <div className="flex items-center gap-1 select-none">
                {index > 0 && (
                  <span className="select-none" aria-hidden>
                    /
                  </span>
                )}
                {isLast ? (
                  <span className="font-medium" aria-current="page">
                    {item.title}
                  </span>
                ) : (
                  <Link
                    to={href}
                    className="hover:text-primary transition-colors"
                    state={location.state}
                  >
                    {item.title}
                  </Link>
                )}
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </nav>
  )
}

export default Breadcrumb
